import Promise from 'promise-polyfill'

const BusinessTripRequestExpense = {
  namespaced: true,
  mutations: {
    reset: (state, payload) => {
    }
  },
  actions: {
    getExpenses: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequestExpense.getBtRequestExpenseUsingGET({id: payload.id, empid: payload.empid})
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    getNewExpense: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequestExpense.addNewBtRequestEmployeeUsingGET_1()
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    addExpense: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        const exp = payload.exp
        // id if exists
        if (typeof exp.id !== 'undefined') { delete exp.id }
        // set sppd id
        exp.sppdEmployee.id = payload.empid
        exp.total = parseFloat(exp.total)
        exp.subTotal = parseFloat(exp.subTotal)
        exp.percentage = parseFloat(exp.percentage)
        vue.$backend.businessTripRequestExpense
          .insertBtRequestEmployeeUsingPOST_1({id: payload.id, empid: payload.empid, exp: exp})
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    deleteExpense: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequestExpense.deleteBtRequestEmployeeUsingDELETE_1({id: payload.id, empid: payload.empid, expid: payload.expid})
          .then(res => {
            resolve()
          })
          .catch(err => reject(err))
      })
    },
    getExpenseById: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequestExpense
          .getBtRequestExpenseByIdUsingGET({id: payload.id, empid: payload.empid, expid: payload.expid})
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    updateExpense: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequestExpense
          .updateBtRequestEmployeeUsingPUT_1({id: payload.id, empid: payload.empid, expid: payload.expid, exp: payload.exp})
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    generateExpense: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequestExpense.generateBtRequestExpenseUsingGET({id: payload.id, empid: payload.empid})
          .then(res => resolve(res.body)).catch(err => reject(err))
      })
    },
    reset: (context, payload) => {
      context.commit('reset', payload)
    }
  }
}

export default BusinessTripRequestExpense



// WEBPACK FOOTER //
// ./src/store/business-trip-request/BusinessTripRequestExpense.js